<template>
  <section class="flex flex-col-reverse xl:grid xl:grid-cols-12 min-h-screen">
    
    <div class="bg-white  xl:col-span-9 px-2 md:px-10 pb-10 pt-5 text-purple-500 font-black flex justify-between flex-col w-full  max-w-max xl:max-w-full mx-auto">
      
      <div class="hidden xl:block">
        <img class="w-16 h-16" src="/logo.png" alt="Logo">
      </div>

      <div class="my-10 xl:my-0">
        <h2 class="text-lg md:text-xl xl:text-2xl">The Best Chat App.</h2>
        <h1 class="text-7xl md:text-8-xl lg:text-9xl">Talk Chat</h1>
      </div>

      <div class="w-full max-w-xl border border-gray-100 shadow-md rounded-xl h-64 overflow-hidden">

        <div v-if="gifNumber === 1" class="px-5 py-10 grid grid-cols-6 h-full gap-8">

          

          <div class="text-purple-500 col-span-4 flex justify-between flex-col">

            <div>
              <h5 class="uppercase text-3xl"> {{chatRoomCount}} chat rooms</h5>
              <h6 class="text-lg">and counting</h6>
            </div>

            <div class="flex space-x-2 w-full col-span-4 row-span-1">
              <div class="text-sm py-1 px-2 rounded-md border border-purple-200 font-normal text-purple-400 w-full flex space-x-0.5">
                  <h6 class="my-auto">Hello World</h6>
                  <div class="w-0.5 h-full bg-purple-500 animate-blink"></div>
              </div>
              <ion-icon class="my-auto text-2xl text-purple-400" name="chatbubble-sharp"></ion-icon>
            </div>
          </div>

          <div class="space-y-2 col-span-2 flex flex-col justify-end">
            <div class="h-3 md:h-4 rounded-full bg-purple-300 animate-pulse w-4/6"></div>
            <div class="h-3 md:h-4 rounded-full bg-purple-300 animate-pulse w-5/6"></div>
            <div class="h-3 md:h-4 rounded-full bg-purple-300 animate-pulse w-full"></div>
            <div class="h-3 md:h-4 rounded-full bg-purple-300 animate-pulse w-4/6"></div>
            <div class="h-3 md:h-4 rounded-full bg-purple-300 animate-pulse w-5/6"></div>
            <div class="h-3 md:h-4 rounded-full bg-purple-300 animate-pulse w-3/6"></div>
            <div class="h-3 md:h-4 rounded-full bg-purple-300 animate-pulse w-full"></div>
          </div>

        </div>

        <div v-else-if="gifNumber === 2" class="grid grid-cols-12 h-full">

          <div class="col-span-7 p-4 flex flex-col">

            <div class="flex space-x-2">
              <ion-icon class="text-2xl mr-1" name="globe-outline"></ion-icon>
              <div class="h-2 sm:h-3 my-auto w-12 sm:w-16 bg-purple-300 rounded-full"></div>
              <div class="h-2 sm:h-3 my-auto w-12 sm:w-16 bg-purple-300 rounded-full"></div>
            </div>

            <div class="my-auto">
              <h5 class="text-3xl sm:text-4xl"> {{activeUsers}} Active Users</h5>
              <h6 class="text-lg sm:text-xl font-normal">across the Globe</h6>
            </div>

          </div>
          <div class="h-full relative col-span-5 bg-red-200">
            <img class="image-full-size cursor-default" src="/mountain.jpg" alt="mountains">
          </div>
          
        </div>

        <div v-else-if="gifNumber === 3" class="grid grid-cols-12 grid-rows-6 gap-1 h-full p-4">

          <div class="col-span-7 row-span-2 bg-purple-500 bg-gradient-to-r from-purple-500  to-pink-500 text-white rounded-lg font-medium grid grid-cols-1 sm:grid-cols-2 p-2">
            <h4 class="text-md">Modern Technologies</h4>
            <div class="text-xl sm:text-4xl flex space-x-1">
              <ion-icon class="my-auto" name="logo-firebase"></ion-icon>
              <ion-icon class="my-auto" name="logo-vue"></ion-icon>
              <ion-icon class="my-auto text-white" src="/tailwind.svg"></ion-icon>
            </div>
          </div>

          <div class="col-span-5 row-span-4 bg-pink-500  text-white h-full rounded-lg p-2 flex justify-around flex-col">
            <h5 class="font-bold text-xl sm:text-2xl">One-tap <br/> Sign in</h5>

            <div class="text-white text-2xl space-x-2">
              <ion-icon name="logo-facebook"></ion-icon>
              <ion-icon name="logo-google"></ion-icon>
              <ion-icon name="person"></ion-icon>
            </div>
          </div>

          <div class="col-span-7 row-span-6 bg-blue-500 bg-gradient-to-b from-blue-300  to-purple-600 text-white rounded-lg pl-4 flex">

            <div class="flex flex-col sm:flex-row sm:space-x-2 my-auto">
              <h4 class="text-2xl sm:text-3xl leading-relaxed tracking-wider uppercase">Features</h4>
              <ion-icon class="text-4xl" name="cloudy-night"></ion-icon>
            </div>

          </div>
          <div class="col-span-5 row-span-4 bg-pink-500 bg-gradient-to-b from-pink-500  via-pink-500 to-red-400 text-white h-full rounded-lg p-2 flex space-x-1">

            <div class="my-auto">
              <ion-icon class="text-3xl sm:text-5xl" name="phone-portrait"></ion-icon>
            </div>
            <h4 class="text-xs sm:text-md my-auto">
              Mobile Responsive
            </h4>

          </div>


        </div>
      </div>

    </div>

    <div class="bg-purple-600  xl:col-span-3 text-white rounded-b-2xl xl:rounded-l-2xl p-3 relative">

      <div class="flex justify-between space-x-2 px-2">
        <div class="xl:hidden">
          <img class="w-12 h-12 white-filter" src="/logo.png" alt="Logo">
        </div>
        <div class="flex justify-end space-x-2">
          <a class="text-gray-200 text-sm font-black hover:underline" href="https://www.songalia.me/">Developer</a>
          <a class="text-gray-200 text-sm font-black hover:underline cursor-pointer" @click="this.$router.push({path: '/privacy'});">Privacy</a>
        </div>
      </div>

      <div class="mt-10 xl:mt-20 flex justify-center space-x-1 lg:space-x-4">
        

        <div class="xl:hidden">
          <img class="h-32 sm:h-48 md:h-80 lg:h-96" src="/hero_pigeon.png" alt="Hero Image">
        </div>
        <div id="firebaseui-auth-container"></div>
      </div>

      <div class="hidden xl:block absolute -left-40 bottom-0">
        <img class="h-96" src="/hero_pigeon.png" alt="Hero Image">
      </div>
    </div>
    
    

  </section>
</template>

<script>
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data (){
    return {
      gifNumber : 1,
      activeUsers : 0,
      chatRoomCount : 0
    }
  },
  mounted (){
    this.initializeSignIn(),
    this.initializeGif()
  },
  beforeUnmount(){
    this.deleteInstace()
  },
  methods : {
    deleteInstace(){
      const ui = firebaseui.auth.AuthUI.getInstance()
      ui.delete();
    },
    initializeGif(){
      const maxGif = 3;
      this.getUserCount();
      this.getChatRoomCount();
      setInterval(()=> {
        if(this.gifNumber < maxGif){
          this.gifNumber++;
        }else{
          this.gifNumber = 1;
        }
      }, 5000);
    },
    getChatRoomCount(){
      firebase.database().ref('chatRooms').get().then((snapshot) => {
        this.chatRoomCount = snapshot.numChildren();
      });
    },
    getUserCount(){
      firebase.database().ref('registeredUsers').get().then((snapshot) => {
        this.activeUsers = snapshot.numChildren();
      });
    },
    initializeSignIn(){
      var uiConfig = {
        signInSuccessUrl: '/',
        signInOptions: [
           {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            scopes: [
              'https://www.googleapis.com/auth/userinfo.profile'
            ],
            buttonColor : '#ffffff',
            iconUrl: '/login-logo/google.svg',
          },
          {
            provider : firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            buttonColor : '#ffffff',
            iconUrl: '/login-logo/facebook.svg',
          },
          {
            provider : firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
            buttonColor : '#ffffff',
            iconUrl: '/login-logo/anonymous.svg',
            fullLabel	: 'Sign in as Guest'
          }
          
        ],
      };

      if(firebaseui.auth.AuthUI.getInstance()) {
        const ui = firebaseui.auth.AuthUI.getInstance()
        ui.start('#firebaseui-auth-container', uiConfig)
      }else {
        const ui = new firebaseui.auth.AuthUI(firebase.auth())
        ui.start('#firebaseui-auth-container', uiConfig)
      }    
    },
  },
}
</script>
<style >
.firebaseui-idp-text, .firebaseui-idp-text-long{
  color: #757575;
  font-size : 0.7rem;
}

.animate-blink {
  animation: blink 1s linear infinite;
}

@keyframes blink {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}  

.white-filter {
  -webkit-filter: brightness(0) invert(1);
  filter: brightness(0) invert(1);
}

</style>
